// extracted by mini-css-extract-plugin
export default {"title":"ActivitiesStaffTab_title__LvrRk","headerLeftTitleWrap":"ActivitiesStaffTab_headerLeftTitleWrap__56VQ2"};